//@flow

import {getProductVisibilityApi, setProductVisibilityApi} from './api';

import type {ProductVisibility, ProductVisibilityRequest} from '../../entities';

export function getProductVisibilityService(): Promise<ProductVisibility> {
  return getProductVisibilityApi().toPromise();
}

export function setProductVisibilityService(
  request: ProductVisibilityRequest
): Promise<ProductVisibility> {
  return setProductVisibilityApi({
    enabledFeatured: request.enabledFeatured,
    enabledRecent: request.enabledRecent,
  }).toPromise();
}
